/**
 * Site footer aligned with coolture_platform `common/Footer`
 * (copyright + terms / privacy / status links).
 */
export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="demo-footer"
      className="mt-auto w-full px-4 pb-6 pt-4"
    >
      <div className="mx-auto flex w-full max-w-2xl flex-col justify-between gap-4 border-t border-slate-200 px-4 py-8 dark:border-slate-700 sm:flex-row sm:items-center sm:gap-0 sm:px-6">
        <div className="font-body text-xs text-slate-500 dark:text-slate-400">
          <a
            href="https://www.kincode.ai"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
            data-testid="demo-footer-copyright"
          >
            &copy; Kincode AI {year}
          </a>
        </div>
        <div
          className="flex flex-row flex-wrap gap-x-8 gap-y-2 font-body text-xs text-slate-500 dark:text-slate-400"
          data-testid="demo-footer-links"
        >
          <a
            href="https://kincode.ai/terms-and-conditions"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
            data-testid="demo-footer-terms"
          >
            Términos y condiciones
          </a>
          <a
            href="https://kincode.ai/privacy-policy"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
            data-testid="demo-footer-privacy"
          >
            Política de privacidad
          </a>
          <a
            href="https://status.kincode.ai"
            target="_blank"
            rel="noreferrer"
            className="hover:underline"
            data-testid="demo-footer-status"
          >
            Estado del servicio
          </a>
        </div>
      </div>
    </footer>
  );
}
